export default __webpack_public_path__ + "static/broadcastImg-6032cb286c54a5e0a82f9c6f96e1e66d.webp";